// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title-section[data-v-7bc16f04]{display:flex;justify-content:center;align-items:center;font-size:16px;height:50px}", ""]);
// Exports
module.exports = exports;
